// Vuex Script
// Version		          : 1.0.0.0
// Template Modified Date : 5-12-2019 10:00:00 AM
// File Created Date      : 5-12-2019 10:00:00 AM
import Vue from 'vue';
import { AppConstants as _app } from '@/shared/app.constants';
import { http } from '@/shared/https';

export default {
    namespaced: true,
    //#. An object containing the data
    state: {
        multiColumn: 2,
        card: {
            type: 'Grid'
        },
        // inlineEditor: {
        //     enabled: true,
        //     autoSave: true,
        //     emptyRow: true
        // },
        actions: {
            listAction: '/api/InitiativeCallWorkflowMap/List/',
            deleteAction: '/api/InitiativeCallWorkflowMap/',
            updateAction: '/api/InitiativeCallWorkflowMap',
            createAction: '/api/InitiativeCallWorkflowMap'
        },
        fields: {
            InitiativeCallWorkflowId: {
                primaryKey: true
            },
            InitiativeCallId: {
                parent: true
            },
            Entity: {
                title: "Screen",
                required: true,
                type: "ComboBox",
                autocomplete: true,
                event: true
            },
            WorkFlowDefinitionId: {
                title: "Workflow",
                required: true,
                type: "ComboBox",
                autocomplete: true,
                event: true
            }
        },
    },
    //#. Used to access data from the state tree of the store
    getters: {},

    //#. Handler functions that perform modifications of data in the state tree
    mutations: {
        //#. fn_formCreated function
        formCreated(state, payload) {
        },

        //#. fn_formCancel function
        formCancel(state, payload) {
        },

        //#. fn_recordCreated function
        recordCreated(state, payload) {
        },

        //#. fn_recordUpdated function
        recordUpdated(state, payload) {
        },

        //#. fn_recordDeleted function
        recordDeleted(state, payload) {
        },

        //#. fn_loadingRecords function
        loadingRecords(state, payload) {
        },

        //#. fn_recordsLoaded function
        recordsLoaded(state, payload) {
        },

        //#. fn_selectionChanged function
        selectionChanged(state, context) {
        },

        //#. fn_itemTypeIdChange function
        itemTypeIdChange(state, context) {
        },

        entityChange(state, context) {
            return http.get(`/api/InitiativeCallWorkflowMap/${context.payload.Value}/Workflow`).then(resp => {
                if (resp.status >= 200 && resp.status < 300) {
                    context.rootState.initiativeCallWorkflowMapIndex.fields
                        .filter(x => x.value == 'WorkFlowDefinitionId')
                        .find(x => x).dropdown = resp.data.Record;

                    context.rootState.initiativeCallWorkflowMapIndex.showInputs = false;
                    Vue.nextTick(() => {
                        context.rootState.initiativeCallWorkflowMapIndex.showInputs = true;
                    });
                }
            });
        }
    },

    //#. Functions that commit mutations. The main difference to Mutations is that Actions can contain asynchronous operations
    actions: {
        //#. formCreated event will be fired
        formCreated: ({ commit, rootState }, payload) => {
            commit('formCreated', { rootState, payload });
        },

        //#. formCancel event will be fired
        formCancel: ({ commit, rootState }, payload) => {
            commit('formCancel', { rootState, payload });
        },

        //#. recordAdded event will be fired
        recordCreated: ({ commit, rootState }, payload) => {
            commit('recordCreated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordUpdated: ({ commit, rootState }, payload) => {
            commit('recordUpdated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordDeleted: ({ commit, rootState }, payload) => {
            commit('recordDeleted', { rootState, payload });
        },
        //#. loadingRecords event will be fired
        loadingRecords: ({ commit, rootState }, payload) => {
            commit('loadingRecords', { rootState, payload });
        },

        //#. recordsLoaded event will be fired
        recordsLoaded: ({ commit, rootState }, payload) => {
            commit('recordsLoaded', { rootState, payload });
        },

        //#. selectionChanged event will be fired	
        selectionChanged: ({ commit, rootState }, payload) => {
            commit('selectionChanged', { rootState, payload });
        },

        //#. itemTypeIdChange event will be fired
        itemTypeIdChange: ({ commit, rootState }, payload) => {
            commit('itemTypeIdChange', { rootState, payload });
        },

        entityChange: ({ commit, rootState }, payload) => {
            commit('entityChange', { rootState, payload });
        }
    }
}
